<section class="headline">
  <h3>File Manager</h3>
  <p>Manage files used throughout the website here. Be careful when deleting files, files cannot be recovered once deleted.</p>
</section>

<anon-file-manager></anon-file-manager>
